var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.5C11.25 10.9142 11.5858 11.25 12 11.25C12.4142 11.25 12.75 10.9142 12.75 10.5H11.25ZM2 4.70981L1.46262 4.18662L0.953258 4.70981L1.46262 5.23299L2 4.70981ZM2 5.47235H8.84211V3.97235H2V5.47235ZM11.25 7.96594V10.5H12.75V7.96594H11.25ZM8.84211 5.47235C10.1531 5.47235 11.25 6.56971 11.25 7.96594H12.75C12.75 5.7794 11.0192 3.97235 8.84211 3.97235V5.47235ZM4.58762 0.976817L1.46262 4.18662L2.53738 5.23299L5.66238 2.02318L4.58762 0.976817ZM1.46262 5.23299L4.58762 8.4428L5.66238 7.39643L2.53738 4.18662L1.46262 5.23299Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoSmall);
export default __webpack_public_path__ + "static/media/undo-small.b0654a4c4f71e6562b467283b1c884ab.svg";
export { ForwardRef as ReactComponent };